import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "input" }
const _hoisted_2 = ["required", "disabled", "value"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass({ isDisabled: _ctx.disabled })
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = false)),
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked) = $event)),
        required: _ctx.required,
        disabled: _ctx.disabled,
        value: _ctx.val
      }, null, 40, _hoisted_2), [
        [_vModelCheckbox, _ctx.checked]
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mimicry" }, [
        _createElementVNode("svg", {
          "data-testid": "service-checkbox",
          class: "mimicry-icon",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            class: "mimicry-checkmark",
            d: "M4.91,12.09L9,16.17L19,7"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "label", {}, undefined, true)
      ])
    ], 2),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ]))
}